module.exports = __webpack_public_path__ + "img/rili.5249267b.png";